/* eslint-disable @typescript-eslint/dot-notation */
import { Injector } from '@angular/core';

import { epicDependencies } from '../../store';

export const epicModuleInjectorTokenContainer = {};

export const setModuleInjector = (injector: Injector): void => {
    const token = Math.random().toString();
    epicModuleInjectorTokenContainer['token'] = token;
    epicDependencies['moduleInjectors'] =
        epicDependencies['moduleInjectors'] ?? [];
    epicDependencies['moduleInjectors'][token] = injector;
};

export const getModuleInjector = (): Injector => {
    const token = epicModuleInjectorTokenContainer['token'];
    return epicDependencies['moduleInjectors'][token];
};
